import PropTypes from "prop-types";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";

function LPEmptyDiv({ content }) {
  return (
    content && (
      <div
        key={`id-${content?.contentful_id}`}
        dangerouslySetInnerHTML={{ __html: content.divContent }}
      />
    )
  );
}

LPEmptyDiv.propTypes = {
  content: PropTypes.shape({
    contentful_id: PropTypes.string.isRequired,
    divContent: PropTypes.string.isRequired,
  }).isRequired,
};

export default withALErrorBoundary({
  name: "LPEmptyDiv",
  priority: "P4",
})(LPEmptyDiv);
